module.exports = __webpack_public_path__ + "static/media/ServerDownMobile2.08956a61.JPG";